import { ConstructionStatus } from '@lopo-tech/lopo-api'
import classNames from 'classnames'
import React from 'react'
import { Tag } from 'src/components/tag/tag'
import { CLASS_PREFIX } from 'src/constants'
import { textResources } from 'src/lang/de'
import { getConstructionStatusLabel } from 'src/utils/construction_status'

import './construction_status_tag.scss'

const cls = `${CLASS_PREFIX}construction-status-tag`

type Props = {
  status?: ConstructionStatus | null;
  // The tile carries the smaller tag of the project tiles, the hero the larger one.
  compact?: boolean;
};

export const ConstructionStatusTag: React.FC<Props> = ({ status, compact }) => {
  const label = getConstructionStatusLabel(textResources.projects, status)

  if (!label) {
    return null
  }

  return (
    <Tag
      text={label}
      gradient
      className={classNames(cls, { [`${cls}--compact`]: compact })}
    />
  )
}
